export const TRANSITIONS = {
  base: 240,
};
